import {composeReducers} from 'common/utils/reducers';
import {makeAsyncReducer} from 'common/utils/simplifiedAsync';
import * as timeSeriesChartActions from 'charts/timeSeries/store/actions';
import * as actions from '../actions';

const EMPTY_ARRAY = [];

export const createAlertsReducer = (action) =>
  makeAsyncReducer(action, {
    shouldSpread: true,
    defaultData: {alertGroups: EMPTY_ARRAY},
    dataProp: 'alertGroups',
  });

export const createMetricsReducer = (stateGroup) =>
  composeReducers((state = {}, {type, payload, meta}) => {
    if (!meta || meta.stateGroup !== stateGroup) {
      return state;
    }
    const defaults = !state[meta.key] ? {hiddenSeries: []} : {};

    switch (type) {
      case actions.fetchAlertMetricDataPoints.TYPE: {
        return {
          ...state,
          [meta.key]: {
            ...state[meta.key],
            ...defaults,
            isLoading: true,
            startDate: payload.startDate,
            endDate: payload.endDate,
            seriesProperties: {byTreeExp: []},
          },
        };
      }

      case actions.fetchAlertMetricDataPoints.success.TYPE: {
        return {...state, [meta.key]: {...state[meta.key], isLoading: false, data: payload}};
      }

      case actions.fetchAlertMetricDataPoints.failure.TYPE: {
        return {...state, [meta.key]: {...state[meta.key], isLoading: false, error: payload}};
      }

      case timeSeriesChartActions.dateRangeChanged.TYPE: {
        return {...state, [meta.key]: {...state[meta.key], zoomRange: payload}};
      }

      case timeSeriesChartActions.resetZoom.TYPE: {
        return {...state, [meta.key]: {...state[meta.key], zoomRange: null}};
      }

      default:
        return state;
    }
  });
